import { render, staticRenderFns } from "./Matched.vue?vue&type=template&id=ad7f3072"
import script from "./Matched.vue?vue&type=script&lang=js"
export * from "./Matched.vue?vue&type=script&lang=js"
import style0 from "./Matched.vue?vue&type=style&index=0&id=ad7f3072&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports